import { Box, BoxProps, Paper, Stack, styled } from "@mui/material";
import { styledOmitPropsOptions } from "../../../theme/styled.helpers";
import { TextInput } from "../../Form";
import { BodyTextM, HeadingS, HeadingXL } from "../../Typography";

export const InvestmentStrategyWrapperStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        display: "flex",
        flexDirection: "column",
        alignItems: "start",
        justifyContent: "start",
        gap: theme.spacing(5),
        width: "100%",
    }),
);

export const InvestmentStrategyTitle = styled(HeadingXL)(({ theme }) =>
    theme.unstable_sx({
        mb: theme.spacing(4),
    }),
);

export const InvestmentStrategyTitleNote = styled(BodyTextM)(({ theme }) =>
    theme.unstable_sx({
        mb: theme.spacing(4),
    }),
);

export const InvestmentStrategyHeadingS = styled(HeadingS)(({ theme }) =>
    theme.unstable_sx({
        m: theme.spacing(0),
    }),
);

export const InvestmentStrategyHeadingWrapperStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "start",
    }),
);

export const GridWrapperBox = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "repeat(2, 1fr)" },
        gridTemplateRows: { xs: "repeat(4, auto)", md: "repeat(2, auto)" },
        gridGap: theme.spacing(4),
        width: "100%",
    }),
);

export const GridItemBox = styled(
    (
        props: BoxProps & {
            $gridRowMd?: string;
            $gridColumnMd?: string;
        },
    ) => {
        return <Box {...props} />;
    },
    styledOmitPropsOptions,
)(({ theme, $gridRowMd, $gridColumnMd }) =>
    theme.unstable_sx({
        backgroundColor: theme.palette.background.paper,
        gridRow: { xs: "auto", md: $gridRowMd ?? "auto" },
        gridColumn: { xs: "auto", md: $gridColumnMd ?? "auto" },
    }),
);

export const SpaceBetweenStack = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row",
        flexWrap: "wrap",
    }),
);

export const BoldBodyTextM = styled(BodyTextM)(({ theme }) =>
    theme.unstable_sx({
        fontWeight: theme.typography.fontWeightBold,
    }),
);

export const NormalBodyTextM = styled(BodyTextM)(({ theme }) =>
    theme.unstable_sx({
        fontWeight: theme.typography.fontWeightRegular,
    }),
);

export const CardPaper = styled(Paper)(({ theme }) =>
    theme.unstable_sx({
        p: theme.spacing(4),
        width: "100%",
    }),
);

export const FundAllocationTextInput = styled(TextInput)(({ theme }) =>
    theme.unstable_sx({
        width: "20%",
        minWidth: "80px",
    }),
);

export const StackWithGap = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        display: "flex",
        flexDirection: "column",
        gap: theme.spacing(4),
    }),
);

export const InputLabelBox = styled(Box)(({ theme }) =>
    theme.unstable_sx({
        flexGrow: 1,
        flexShrink: 0,
        flexBasis: "70%",
    }),
);

export const WarningWrapper = styled(Stack)(({ theme }) =>
    theme.unstable_sx({
        width: "100%",
    }),
);
